import comp from "./CodeCell";

export default comp;
